import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {first, take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {ockUser} from "../interface/ockUser";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class OckUserService {
  private readonly userListSubject: ReplaySubject<CountedAndPaginated<ockUser>>
    = new ReplaySubject<CountedAndPaginated<ockUser>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService
  ) {
  }

  public getListSubject(): ReplaySubject<CountedAndPaginated<ockUser>> {
    return this.userListSubject;
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/ock/user?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<ockUser>) => {
        this.userListSubject.next(result);
      });
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/ock/user/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}

